import { Controller } from "stimulus";

// this controller is applied to a popover which is
// dynamically created in legs_popover_controller.js
export default class extends Controller {
  static values = {
    legs: Array,
    rootLegId: Number,
  };

  initialize() {
    console.log("initialize");
  }

  connect() {
    console.log("connect");
  }

  confirm() {
    const event = new CustomEvent(`cortana:legs-confirmed-${this.rootLegIdValue}`, {
      bubbles: true,
      detail: {
        confirmedLegs: this.legsValue,
      },
    });

    document.body.dispatchEvent(event);
  }

  cancel() {
    const event = new CustomEvent(`cortana:legs-cancelled-${this.rootLegIdValue}`, {
      bubbles: true,
    });

    this.element.dispatchEvent(event);
  }

  change(event) {
    event.currentTarget.classList.toggle("selected");
    const toggledLegId = Number(event.currentTarget.dataset.legId);
    if (this.legsValue.includes(toggledLegId)) {
      this.legsValue = this.legsValue.filter((legId) => legId != toggledLegId);
    } else {
      this.legsValue = this.legsValue.concat([toggledLegId]);
    }
  }
}
